import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchBillingPlans } from 'api/subscriptions';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { GivebutterPlusPlan } from 'types/domain';

const useSubscriptionPlans = () => {
    const { accountId } = useCurrentAccount();
    return useSuspenseQuery({
        queryKey: accountQueryKeys.billingPlans(accountId),
        queryFn: () => fetchBillingPlans(accountId),
        select: data =>
            data.plans.map(plan => ({
                ...plan,
                billing: getPlanTotalCost(plan),
            })),
    });
};

const getPlanTotalCost = (plan: GivebutterPlusPlan) => {
    const { total_monthly, total_yearly } = plan;

    return {
        yearly_billing_cycle: {
            perMonth: total_yearly / 12,
            perYear: total_yearly,
        },
        monthly_billing_cycle: {
            perMonth: total_monthly,
            perYear: total_monthly * 12,
        },
    };
};

export { useSubscriptionPlans };
